module.exports = __webpack_public_path__ + "static/media/unpin.b13328f9.svg";